// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__gwEVh","title":"style_title__2kMGO","subtitle":"style_subtitle__BEcyx"};